<template>
    <FormSection
        title="Patient Language"
        type="his-section"
        :full-height="false"
        :application-id="Number(currentApplication)"
    >
        <template v-slot:content>
            <section class="row py-3 pb-0 g-0">
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    <span class="badge me-1">A1110A</span> What is your preferred language?

                                    <span class="text-danger">*</span>
                                </label>

                                <TypeaheadInput
                                    id="Referral_Preferred_Language"
                                    :getData="getLanguagesFilter"
                                    :value="referral.Demographics.PreferredLanguage"
                                    v-on:valueChanged="updateLanguage"
                                    :show-all-by-default="true"
                                    :open-on-focus="true"
                                    placeholder="Enter Preferred Langauge"
                                    :isError="preferredLanguageError"
                                ></TypeaheadInput>
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    Additional Language
                                </label>
                                <input
                                    id="Referral_Preferred_Language"
                                    name="referral-preferred-language"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Text"
                                    v-model="referral.Demographics.AdditionalLanguage1"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    Additional Language
                                </label>
                                <input
                                    id="Referral_Preferred_Language"
                                    name="referral-preferred-language"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Text"
                                    v-model="referral.Demographics.AdditionalLanguage2"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    Additional Language
                                </label>
                                <input
                                    id="Referral_Preferred_Language"
                                    name="referral-preferred-language"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Text"
                                    v-model="referral.Demographics.AdditionalLanguage3"
                                />
                            </div>

                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name"> Auxiliary Aids </label>
                                <input
                                    id="Referral_auxiliary_aid"
                                    name="referral-auxiliary_aid"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Type"
                                    v-model="referral.Demographics.AuxiliaryAids"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="row">
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    <span class="badge me-1">A1110B</span> Do you need or want an interpreter to
                                    communicate with a doctor or health care staff?
                                    <span class="text-danger">*</span>
                                </label>
                                <div
                                    :class="`${
                                        v$.referral.Demographics.NeedInterpreter.$error ||
                                        errors.Demographics.includes('NeedInterpreter')
                                            ? 'border border-warning rounded p-2'
                                            : ''
                                    }`"
                                >
                                    <div class="form-check custom-radio pb-1">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="no"
                                            value="0"
                                            :checked="referral.Demographics.NeedInterpreter === '0'"
                                            @click="handleNeedInterpreterChange('0')"
                                            @blur="v$.referral.Demographics.NeedInterpreter.$touch"
                                        />
                                        <label class="form-check-label mb-2" for="no"> No </label>
                                    </div>
                                    <div class="form-check custom-radio pb-1">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="yes"
                                            value="1"
                                            :checked="referral.Demographics.NeedInterpreter === '1'"
                                            @click="handleNeedInterpreterChange('1')"
                                            @blur="v$.referral.Demographics.NeedInterpreter.$touch"
                                        />

                                        <label class="form-check-label mb-2" for="yes"> Yes </label>
                                    </div>
                                    <div class="form-check custom-radio pb-1">
                                        <input
                                            type="radio"
                                            class="form-check-input"
                                            id="unable"
                                            value="2"
                                            :checked="referral.Demographics.NeedInterpreter === '2'"
                                            @click="handleNeedInterpreterChange('2')"
                                            @blur="v$.referral.Demographics.NeedInterpreter.$touch"
                                        />

                                        <label class="form-check-label mb-2" for="unable"> Unable to Determine </label>
                                    </div>
                                </div>
                                <div class="col-12 py-2 px-0" v-if="referral.Demographics.NeedInterpreter == '1'">
                                    <div class="w-100">
                                        <h6 class="mb-2 d-flex align-items-center">
                                            <b class="me-2"> Interpreter</b>
                                        </h6>
                                    </div>
                                    <div
                                        class="form-check custom-checkbox pb-1"
                                        v-for="interpreter of referralOptions.interpreterOptionsOasisE"
                                    >
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            :id="`interpreter-${interpreter.value}`"
                                            :value="interpreter.value"
                                            @change="handleInterpreterRequired(interpreter.value)"
                                        />

                                        <label class="form-check-label mb-2" :for="`interpreter-${interpreter.value}`">
                                            {{ interpreter.text }}</label
                                        >
                                    </div>
                                    <template v-if="showOther()">
                                        <div class="d-flex bg-white flex-column pb-4 ms-4">
                                            <label class="mb-1 mt-1 service-required-text-color"
                                                >Other Interpreter</label
                                            >
                                            <input
                                                type="text"
                                                maxlength="100"
                                                class="ms-1 form-control w-90"
                                                placeholder="Enter Interpreter"
                                                v-model="referral.Demographics.InterpreterOther"
                                            />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientLanguage.ts"></script>

<style lang="scss">
.service-required-wrapper:has(.service-required-input:checked) {
    background-color: $homecare-primary;
    color: #fff;
}

.service-required-text-color {
    color: $app-text-color;
}
</style>
